import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";
import Link from "@mui/material/Link";
//
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import imagen from "../src/encabezado.jpg";

function Inscripciones() {
	// estados
	const { id } = useParams();
	const [dni, setDNI] = useState("");
	const [telefono, setTelefono] = useState("");
	const [nombre, setNombre] = useState("");
	const [apellido, setApellido] = useState("");
	const [email, setEmail] = useState("");
	const [vendedor, setVendedor] = useState("");
	const [esParticipante, setEsParticipante] = useState(false);
	const [msgok, setMsgok] = useState(false);
	const [msgno, setMsgno] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [openError, setOpenError] = React.useState(false);

	const [titulo, setTitulo] = useState("");
	const [mensaje, setMensaje] = useState("");
	const [leyenda, setLeyenda] = useState("");

	//const navigate = useNavigate()
	// funciones
	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClickOpenError = () => {
		setOpenError(true);
	};

	const handleClose = () => {
		setOpen(false);
		//window.location.href = '/';
	};

	const handleCloseError = () => {
		setOpenError(false);
		//window.location.href = '/';
	};
	//
	const handleSubmit = async (event) => {
		event.preventDefault();
		localStorage.setItem("dni", JSON.stringify(dni));
		localStorage.setItem("email", JSON.stringify(email));
		localStorage.setItem("telefono", JSON.stringify(telefono));
		localStorage.setItem("nombre", JSON.stringify(nombre));
		localStorage.setItem("apellido", JSON.stringify(apellido));
		setEsParticipante(true);
		//
		const postData = {
			fecha: new Date(),
			email: email,
			dni: dni,
			telefono: telefono,
			nombre: nombre,
			sucursal: id,
			vendedor: vendedor,
			apellido: apellido,
		};
		try {
			const baseURL = process.env.REACT_APP_SERVER_PATH + "addInscripcion";
			const res = await fetch(`${baseURL}`, {
				method: "post",
				headers: {
					"Content-Type": "application/json",
					"x-access-token": "token-value",
					"Access-Control-Allow-Origin": "*",
				},
				body: JSON.stringify(postData),
			});
			switch (res.status) {
				case 200:
					setTitulo("Inscripción Correcta");
					setMensaje("Inscripción realizada correctamente");
					setLeyenda("Inscripción realizada correctamente");
					setEsParticipante(true);
					setOpen(true);
					break;
				case 400:
					setTitulo("Error en la Inscripción-1");
					setMensaje("Error en la Inscripción-2");
					setLeyenda("Error en la Inscripción");
					setOpenError(true);
					break;
				case 410:
					setTitulo("¡Ya participo en el dia!");
					setMensaje("¡Ya participo en el dia!");
					setLeyenda("¡Ya participo en el dia!");
					setOpenError(true);
					break;
				default:
					setTitulo("Error en la Inscripción");
					setMensaje("Error en la Inscripción");
					setLeyenda("Error en la Inscripción");
					setOpenError(true);
					break;
			}
			/*     if (res.status === 200) {
                      setLeyenda(res.statusText);
                      //setMsgok(true);
                      handleClickOpen();
                      setEmail('');
                      setDNI('');
                      
                    } else
                     {
                      //setMsgno(true);
                      console.log(err.message);
                      //setLeyenda(res);
                      handleClickOpenError();
                     }*/
		} catch (err) {
			console.log(err.message);
		}
	};

	const getLocalStorage = () => {
		const lsDNI = JSON.parse(localStorage.getItem("dni"));
		if (lsDNI === null) {
			setEsParticipante(false);
		} else {
			setEsParticipante(true);
			setDNI(JSON.parse(localStorage.getItem("dni")));
			setEmail(JSON.parse(localStorage.getItem("email")));
			setTelefono(JSON.parse(localStorage.getItem("telefono")));
			setNombre(JSON.parse(localStorage.getItem("nombre")));
			setApellido(JSON.parse(localStorage.getItem("apellido")));
		}
	};

	const getMensaje = () => {
		const baseURL = process.env.REACT_APP_SERVER_PATH + "mensaje";
		fetch(`${baseURL}`)
			.then((res) => res.json())
			.then(
				(result) => {
					setTitulo(result[0].titulo);
					setMensaje(result[0].cuerpo);
				},
				(error) => {}
			);
	};

	useEffect(() => {
		getLocalStorage();
		getMensaje();
	}, []);
	return (
		<div>
			<Container component="main" maxWidth="sm">
				<div className="container">
					<img className="responsive-image" src={imagen} alt="" />
				</div>
				<Box component="form" onSubmit={handleSubmit} sx={{ mt: 4 }}>
					<Grid item xs={12}>
						<h1>Datos para el sorteo</h1>
					</Grid>
					<Grid container spacing={3}>
						{/* RENDERIZADO PARA LA PRIMERA PARTICIPACION */}

						<Grid item xs={12}>
							<TextField
								autoComplete="given-name"
								name="dni"
								required
								fullWidth
								id="dni"
								label="DNI"
								value={dni}
								onChange={(e) => {
									const value = e.target.value;
									// Permite solo números usando una expresión regular
									if (/^\d*$/.test(value)) {
										setDNI(value); // Actualiza el estado solo si es numérico
									}
								}}
								helpertext="Campo requerido"
								variant="filled"
								disabled={esParticipante}
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								name="nombre"
								required
								fullWidth
								id="nombre"
								label="Nombre"
								type="text"
								value={nombre}
								onChange={(e) => setNombre(e.target.value)}
								helpertext="Campo requerido"
								variant="filled"
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								name="apellido"
								required
								fullWidth
								id="apellido"
								label="Apellido"
								type="text"
								value={apellido}
								onChange={(e) => setApellido(e.target.value)}
								helpertext="Campo requerido"
								variant="filled"
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								required
								fullWidth
								id="email"
								label="Correo Electrónico"
								name="email"
								autoComplete="email"
								type="email"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
								helpertext="Campo requerido"
								variant="filled"
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								required
								fullWidth
								id="contacto"
								label="Telefono"
								name="contacto"
								autoComplete="Nombre Contacto"
								type="text"
								value={telefono}
								onChange={(e) => {
									const value = e.target.value;
									// Permite solo números usando una expresión regular
									if (/^\d*$/.test(value)) {
										setTelefono(value); // Actualiza el estado solo si es numérico
									}
								}}
								helpertext="Campo requerido"
								variant="filled"
							/>
						</Grid>
						<Grid item xs={12}>
							<TextField
								fullWidth
								id="Vendedor"
								label="Vendedor o Nro. de ticket"
								name="Vendedor"
								autoComplete="Nombre del Vendedor"
								type="text"
								value={vendedor}
								onChange={(e) => setVendedor(e.target.value)}
								helperText="Opcional"
								variant="filled"
                placeholder="Vendedor o Nro. de ticket"
							/>
						</Grid>
					</Grid>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						sx={{ mt: 4, mb: 4 }}
					>
						Participar
					</Button>
					<Grid item xs={12}>
						<Link sx={{ mt: 2 }} align="center" href="/Terminos">
							Términos y Condiciones
						</Link>
						<br />
						<br />
						<Link sx={{ mt: 2 }} align="center" href="/ComerciosAdheridos">
							Comercios Adheridos
						</Link>
					</Grid>
					<Snackbar
						open={msgok}
						autoHideDuration={6000}
						onClose={() => setMsgok(false)}
					>
						<Alert severity="success" variant="filled">
							<AlertTitle>Registro Correcto</AlertTitle>
							Gracias por registrarse, debe aguardar a que la UCIP habilite su
							registro
						</Alert>
					</Snackbar>

					<Snackbar
						open={msgno}
						autoHideDuration={6000}
						onClose={() => setMsgno(false)}
					>
						<Alert severity="info" variant="filled">
							<AlertTitle>Error</AlertTitle>
							{leyenda}
						</Alert>
					</Snackbar>
				</Box>
				{/*  ok */}
				<Dialog
					open={open}
					onClose={handleClose}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">{titulo}</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{mensaje}
							<br />
							<br />
							<Link sx={{ mt: 2 }} align="center" href="/Terminos">
								Términos y Condiciones
							</Link>
							<br />
							<br />
							<Link sx={{ mt: 2 }} align="center" href="/ComerciosAdheridos">
								Comercios Adheridos
							</Link>
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							color="primary"
							variant="contained"
							onClick={handleClose}
							autoFocus
						>
							Cerrar
						</Button>
					</DialogActions>
				</Dialog>
				{/*  ERROR */}
				<Dialog
					open={openError}
					onClose={handleCloseError}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title">Informe</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-description">
							{leyenda}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							color="primary"
							variant="contained"
							onClick={handleCloseError}
							autoFocus
						>
							Cerrar
						</Button>
					</DialogActions>
				</Dialog>
			</Container>
		</div>
	);
}

export default Inscripciones;
